import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const userCancelledVideoUpload = (strGuid) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.USER_CANCELLED_VIDEO_UPLOAD(strGuid)
  );
};

export default userCancelledVideoUpload;
